import { render, staticRenderFns } from "./submitForInspectionLabel.vue?vue&type=template&id=19b3b282&scoped=true&"
import script from "./submitForInspectionLabel.vue?vue&type=script&lang=js&"
export * from "./submitForInspectionLabel.vue?vue&type=script&lang=js&"
import style0 from "./submitForInspectionLabel.vue?vue&type=style&index=0&id=19b3b282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b3b282",
  null
  
)

export default component.exports